@if (showLanguageList()) {
  <lp-language-tabs [languages]="languageTabs()" [(activeIndex)]="activeIndex" />
}

<ng-template #titelInput>
  @if (activeTitelField(); as titelField) {
    <div class="dm-margin-top-16">
      <!-- `required` and the error message come from the schema; binding either alongside
           `formField` is NG8022. -->
      <dm-input
        [label]="titelLabel() ?? defaultTitelLabel"
        [tooltip]="titelTooltip()"
        inputtype="text"
        dmSize="md"
        inputId="uebersetzungen-pdf-upload-titel"
        [formField]="titelField"
      />
    </div>
  }
</ng-template>

@if (activeEntry(); as entry) {
  <!-- A Titel that names the document follows it; one that names the entry leads. -->
  @if (!titelNamesDocument()) {
    <ng-container [ngTemplateOutlet]="titelInput" />
  }

  <div class="lp-uebersetzungen-pdf-upload__pdf dm-margin-top-16">
    <dm-label
      gapBottom="none"
      [as]="showsUploadControl() ? 'label' : 'span'"
      [for]="showsUploadControl() ? pdfInputId : undefined"
      i18n="@@common.uebersetzungenPdfUpload.label"
      >PDF</dm-label
    >

    @if (entry.dateiUrl) {
      <dm-card>
        <dm-card-body>
          <div class="lp-uebersetzungen-pdf-upload__current">
            <!-- `href` makes dm-button render a real anchor, so the file icon can live inside it. -->
            <dm-button color="link-color" size="sm" target="_blank" rel="noopener" [href]="entry.dateiUrl">
              <dm-icon slot="leading" name="file-05" />
              @if (activeDocumentName(); as documentName) {
                <span class="lp-uebersetzungen-pdf-upload__name" [title]="documentName">{{ documentName }}</span>
              } @else {
                <span i18n="@@common.uebersetzungenPdfUpload.open">Aktuelles PDF öffnen</span>
              }
            </dm-button>
            <dm-tooltip class="dm-margin-left-auto" placement="bottom" [label]="deleteLabel">
              <dm-button-utility
                size="sm"
                color="tertiary"
                iconName="trash-01"
                [label]="deleteLabel"
                [disabled]="isUploading()"
                (click)="removePdf()"
              />
            </dm-tooltip>
          </div>
        </dm-card-body>
      </dm-card>
      @if (showStableLinkHint()) {
        <!-- prettier-ignore -->
        <p class="dm-text-sm dm-color-text-tertiary" i18n="@@common.uebersetzungenPdfUpload.stableLink">Diese Adresse bleibt gleich – auch wenn Sie das PDF löschen und ein neues hochladen.</p>
      }
    } @else if (canUploadPdf()) {
      <dm-fileupload
        [id]="pdfInputId"
        variant="bar"
        outputformat="file"
        [multiple]="false"
        [mimetypes]="pdfMimetype"
        [maxsize]="maxPdfBytes"
        [hint]="pdfHint"
        [disabled]="isUploading()"
        [uploadtext]="uploadCtaLabel"
        [dragdroptext]="dragDropLabel"
        (dmFileuploadFileChange)="filePicked($event.detail)"
      />
    } @else {
      <!-- prettier-ignore -->
      <p class="dm-text-sm dm-color-text-tertiary" i18n="@@common.uebersetzungenPdfUpload.saveFirst">Speichern Sie den Eintrag zuerst – danach lässt sich je Sprache ein PDF hochladen.</p>
    }
  </div>

  @if (titelNamesDocument()) {
    <ng-container [ngTemplateOutlet]="titelInput" />
  }
}
